<template>
  <Head>
    <Title>Lifestyle - Ludmila Zacharová</Title>
  </Head>
  <siteblocks-navmenu />
  <v-container>
    <v-sheet class="mx-4">
      <h1>Lifestyle</h1>
      <div class="mb-5">
        <br>
        Jeden den Vašeho života
        <br><br>
        Každodenní chvíle mají svou jedinečnost a kouzlo. Lifestyle focení v pohodlí Vašeho domova zachytí Vás takové, jací opravdu jste – při vaření, čtení, péči o květiny, nebo hraní si s dětmi.
        Zachytím Vaši něhu, objetí s dětmi, lásku mezi Vámi a Vaším partnerem. Opravdové emoce, které mezi sebou sdílíte, jsou tím nejcennějším.
        Bez póz, bez spěchu, v přirozeném světle a rytmu Vašeho dne.
        <br><br>
        Vytvoříme spolu vzpomínky, které budou mít pro Vás skutečný význam – protože to nejsou jen krásné fotografie, ale příběh Vaší rodiny.
        <br><br>
        Chcete někomu udělat radost? Toto focení si můžete koupit jako dárek. Mám pro vás připravené krásné dárkové poukazy.
        <br><br>
        Rezervace termínu nebo objednávka poukazu v soukromých zprávách.
        <br><br>
      </div>
    </v-sheet>
    <v-row v-for="index in 9">
      <v-col cols="12" md="6">
        <v-img :src="'/lifestyle/' + (index * 2 - 1) + '.jpg'" aspect-ratio="4:3"/>
      </v-col>
      <v-col cols="12" md="6">
        <v-img :src="'/lifestyle/' + (index * 2) + '.jpg'" aspect-ratio="4:3"/>
      </v-col>
    </v-row>

    <v-row v-for="index in 3">
      <v-col cols="12" md="6">
        <v-img :src="'/lifestyle/' + (index * 2 + 17) + '.jpg'" aspect-ratio="3:4"/>
      </v-col>
      <v-col cols="12" md="6">
        <v-img :src="'/lifestyle/' + (index * 2 + 18) + '.jpg'" aspect-ratio="3:4"/>
      </v-col>
    </v-row>
  </v-container>
</template>